import AltInstance from '../../../../Common/Globals/Scripts/AltInstance';

class RatesAuditActions {
    constructor() {
        this.generateActions('auditRecordsLoaded', 'searchResultsInvalidated');
    }
}

export default AltInstance.createActions(RatesAuditActions);
